// @flow
'use strict';

import CamposCte from './campos_cte';

export default CamposCte;